import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IonicModule } from '@ionic/angular';
import { ButtonComponent } from './components/button/button.component';
import { InputComponent } from './components/input/input.component';
import { TextareaComponent } from './components/textarea/textarea.component';
import { CheckboxComponent } from './components/checkbox/checkbox.component';
import { HeaderComponent } from './components/header/header.component';
import { ToolbarComponent } from './components/toolbar/toolbar.component';
import { ToolbarButtonComponent } from './components/toolbar-button/toolbar-button.component';
import { ContentTitleComponent } from './components/content-title/content-title.component';
import { StickyContentComponent } from './components/sticky-content/sticky-content.component';
import { FooterComponent } from './components/footer/footer.component';
import { BackButtonComponent } from './components/back-button/back-button.component';
import { MenuButtonComponent } from './components/menu-button/menu-button.component';
import { ItemComponent } from './components/item/item.component';
import { TranslateModule } from '@ngx-translate/core';
import { ClientInfoComponent } from './components/client-info/client-info.component';
import { RoutedModalComponent } from './components/routed-modal/routed-modal.component';
import { DayMoveButtonsComponent } from './components/day-move-buttons/day-move-buttons.component';
import { AgendaDatepickerComponent } from './components/agenda-datepicker/agenda-datepicker.component';
import { MomentPipe } from './pipes/moment/moment.pipe';
import { DurationPipe } from './pipes/duration/duration.pipe';
import { ClientsListComponent } from './components/clients-list/clients-list.component';
import { AppointmentPillComponent } from '@shared/components/appointment-pill/appointment-pill.component';
import  { SignaturePadModule } from '@flowww/signaturepad';
import { LoaderComponent } from './components/loader/loader.component';
import { SignaturePadModal } from '@shared/components/signature-pad/signature-pad.modal';
import { ClientsListSkeletonComponent } from './components/clients-list-skeleton/clients-list-skeleton.component';
import { DatepickerComponent } from './components/datepicker/datepicker.component';
import { FormsModule } from '@angular/forms';
import { AvatarComponent } from './components/avatar/avatar.component';
import { AppointmentEditTagsModal } from './components/appointment-edit-tags/appointment-edit-tags.modal';
import { AppointmentEditCommentsModal } from '@shared/components/appointment-edit-comments/appointment-edit-comments.modal';
import { SeparatorComponent } from './components/separator/separator.component';
import { CollapseButtonComponent } from './components/collapse-button/collapse-button.component';
import { AudioTranscriberComponent } from './components/audio-transcriber/audio-transcriber.component';
import { InformationModalComponent } from './components/information/information.modal';

@NgModule({
    declarations: [
        AgendaDatepickerComponent,
        AppointmentPillComponent,
        AudioTranscriberComponent,
        BackButtonComponent,
        ButtonComponent,
        CheckboxComponent,
        ClientInfoComponent,
        ClientsListComponent,
        ClientsListSkeletonComponent,
        CollapseButtonComponent,
        ContentTitleComponent,
        DatepickerComponent,
        DayMoveButtonsComponent,
        DurationPipe,
        FooterComponent,
        HeaderComponent,
        InformationModalComponent,
        InputComponent,
        ItemComponent,
        LoaderComponent,
        MenuButtonComponent,
        MomentPipe,
        RoutedModalComponent,
        SeparatorComponent,
        SignaturePadModal,
        StickyContentComponent,
        TextareaComponent,
        ToolbarButtonComponent,
        ToolbarComponent,
        AvatarComponent,
        AppointmentEditTagsModal,
        AppointmentEditCommentsModal,
    ],
    exports: [
        AgendaDatepickerComponent,
        AppointmentPillComponent,
        AudioTranscriberComponent,
        BackButtonComponent,
        ButtonComponent,
        CheckboxComponent,
        ClientInfoComponent,
        ClientsListComponent,
        ClientsListSkeletonComponent,
        CollapseButtonComponent,
        ContentTitleComponent,
        DatepickerComponent,
        DayMoveButtonsComponent,
        DurationPipe,
        FooterComponent,
        HeaderComponent,
        InformationModalComponent,
        InputComponent,
        ItemComponent,
        LoaderComponent,
        MenuButtonComponent,
        MomentPipe,
        RoutedModalComponent,
        SeparatorComponent,
        StickyContentComponent,
        TextareaComponent,
        ToolbarButtonComponent,
        ToolbarComponent,
        TranslateModule,
        AppointmentEditTagsModal,
        AppointmentEditCommentsModal,
    ],
    imports: [
        CommonModule,
        IonicModule,
        SignaturePadModule,
        TranslateModule,
        FormsModule
    ],
    schemas: [
        CUSTOM_ELEMENTS_SCHEMA
    ]
})
export class SharedModule {
}
